import { ToastContainer } from 'react-toast';
import CustomerPages from './Components/CustomerPages/CustomerPages';
import 'reactjs-popup/dist/index.css';
import "simplebar/src/simplebar.css";
import Loader from './Util/Loader';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import axiosApi from "./core/interceptor/interceptor";
import { config } from './config';
import LogRocket from 'logrocket';

export default function App() {
  const loader = useSelector((state) => state.loader.value);
  
  useEffect(() => {
    if (localStorage.getItem('token')) {
      axiosApi.get(`${config.apiUrl}/users/me`).then((res) => {
        if (res) {
          startLogRocket(res.data.data.email, res.data.data.full_name);
        }
      });
    }
    console.log('--New Deployement--');
  }, []);

  const startLogRocket = (email, name) => {
    if (config.logRocketId?.length && email !== 'ishan@clerisysolutions.com') {
      LogRocket.startNewSession();
      LogRocket.init(config.logRocketId, {
        network: {
          requestSanitizer: request => {
            if (request.url.toLowerCase().includes('login') || request.url.toLowerCase().includes('change-password')) {
              return null;
            }
            return request;
          },
        },
      });
      LogRocket.identify(email, {
        name,
        email,
      });
    }
  }
  return (
    <div className="App">
      <ToastContainer
        delay={6000}
        position={'top-right'}
        
      />
      <CustomerPages />
      {loader && <Loader />}
    </div>
  );
}
